import { render, staticRenderFns } from "./OrderSummaryPopup.vue?vue&type=template&id=1668710d&"
import script from "./OrderSummaryPopup.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports